module.exports = __webpack_public_path__ + "img/BigCheck.889d8a15.svg";